import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'log'})
export class LogPipe implements PipeTransform {
    transform(s: any): any {
        console.log(s);
        return s;
    }
}
